import { Component, inject } from '@angular/core';
import { ModalRef } from '@siemens/element-ng/modal';

@Component({
    selector: 'app-energy-retirement-notice',
    templateUrl: './energy-retirement-notice.component.html',
    styleUrls: ['./energy-retirement-notice.component.scss'],
    standalone: false
})
export class EnergyRetirementNoticeComponent {
    public modalRef = inject(ModalRef);
}
